(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarVideoSlider(seccion) {
    var pista = seccion.querySelector('[data-vs-pista]');
    if (!pista) return;

    var slides = pista.children;

    var reproductores = seccion.querySelectorAll('[data-vs-video]');
    reproductores.forEach(function (envoltorio) {
      var video = envoltorio.querySelector('video');
      var boton = envoltorio.querySelector('[data-vs-play]');
      if (!video || !boton) return;

      boton.addEventListener('click', function () {
        reproductores.forEach(function (otro) {
          if (otro !== envoltorio) {
            var v = otro.querySelector('video');
            if (v) { v.pause(); }
          }
        });
        var promesa = video.play();
        if (promesa && promesa.catch) { promesa.catch(function () {}); }
      });

      video.addEventListener('play', function () {
        envoltorio.classList.add('esta-reproduciendo');
        video.setAttribute('controls', '');
      });

      video.addEventListener('pause', function () {
        envoltorio.classList.remove('esta-reproduciendo');
      });

      video.addEventListener('ended', function () {
        envoltorio.classList.remove('esta-reproduciendo');
        video.removeAttribute('controls');
        try { video.currentTime = 0; } catch (e) {}
      });
    });

    var prev = seccion.querySelector('[data-vs-prev]');
    var next = seccion.querySelector('[data-vs-next]');

    function desplazar(direccion) {
      if (!slides.length) return;
      var primera = slides[0];
      var separacion = parseFloat(window.getComputedStyle(pista).columnGap) || 14;
      var paso = primera.clientWidth + separacion;
      pista.scrollBy({ left: direccion * paso, behavior: 'smooth' });
    }

    if (prev) { prev.addEventListener('click', function () { desplazar(-1); }); }
    if (next) { next.addEventListener('click', function () { desplazar(1); }); }

    var contenedorPuntos = seccion.querySelector('[data-vs-puntos]');
    if (contenedorPuntos && slides.length) {
      contenedorPuntos.innerHTML = '';
      var puntos = [];

      for (var i = 0; i < slides.length; i++) {
        var punto = document.createElement('button');
        punto.type = 'button';
        punto.className = 'video-slider__punto';
        punto.setAttribute('aria-label', 'Ir al vídeo ' + (i + 1));

        (function (indice) {
          punto.addEventListener('click', function () {
            var slide = slides[indice];
            var slideRect = slide.getBoundingClientRect();
            var pistaRect = pista.getBoundingClientRect();
            var destino = pista.scrollLeft + (slideRect.left - pistaRect.left) - (pista.clientWidth - slide.clientWidth) / 2;
            pista.scrollTo({ left: destino, behavior: 'smooth' });
          });
        })(i);

        contenedorPuntos.appendChild(punto);
        puntos.push(punto);
      }

      var actualizar = function () {
        var centro = pista.scrollLeft + pista.clientWidth / 2;
        var activo = 0;
        var menor = Infinity;

        for (var j = 0; j < slides.length; j++) {
          var c = slides[j].offsetLeft + slides[j].clientWidth / 2;
          var d = Math.abs(c - centro);
          if (d < menor) { menor = d; activo = j; }
        }

        for (var k = 0; k < puntos.length; k++) {
          if (k === activo) { puntos[k].classList.add('esta-activo'); }
          else { puntos[k].classList.remove('esta-activo'); }
        }
      };

      actualizar();
      pista.addEventListener('scroll', function () {
        window.requestAnimationFrame(actualizar);
      });
    }
  }

  function iniciarTodo() {
    var secciones = document.querySelectorAll('.seccion-video-slider');
    for (var i = 0; i < secciones.length; i++) {
      iniciarVideoSlider(secciones[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var seccion = e.target.querySelector('.seccion-video-slider');
    if (seccion) { iniciarVideoSlider(seccion); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
